import { render, staticRenderFns } from "./WorkoutBuilder.vue?vue&type=template&id=18f4a7a2&scoped=true"
import script from "./WorkoutBuilder.vue?vue&type=script&lang=js"
export * from "./WorkoutBuilder.vue?vue&type=script&lang=js"
import style0 from "./WorkoutBuilder.vue?vue&type=style&index=0&id=18f4a7a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4a7a2",
  null
  
)

export default component.exports